export default __webpack_public_path__ + "static/media/netflix.994a3b8b.svg";